/* Homepage-slideshow: pijltjes, bolletjes en automatisch doorschuiven (pauzeert bij hover/aanraken). */
(function () {
  function init(root) {
    var track = root.querySelector('.gs-slider__track');
    var slides = root.querySelectorAll('.gs-slider__slide');
    var dots = root.querySelectorAll('.gs-slider__dot');
    if (!track || slides.length < 2) return;
    var index = 0;
    var timer = null;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function go(i) {
      index = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[index].offsetLeft - track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    }
    function mark() {
      dots.forEach(function (d, i) {
        d.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }
    function start() {
      if (reduce) return;
      stop();
      timer = setInterval(function () { go(index + 1); }, 7000);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    track.addEventListener('scroll', function () {
      var w = track.clientWidth || 1;
      var i = Math.round(track.scrollLeft / w);
      if (i !== index) { index = i; mark(); }
    }, { passive: true });

    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); start(); }); });
    var prev = root.querySelector('[data-gs-prev]');
    var next = root.querySelector('[data-gs-next]');
    if (prev) prev.addEventListener('click', function () { go(index - 1); start(); });
    if (next) next.addEventListener('click', function () { go(index + 1); start(); });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('touchstart', stop, { passive: true });
    root.addEventListener('touchend', start, { passive: true });
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });

    mark();
    start();
  }
  function boot() { document.querySelectorAll('[data-gs-slider]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
